@let isMobile = isMobile$ | async;

@if (isMobile) {
  <app-search-bar
    [isMobile]="isMobile"
    [searchType]="searchType"
    [airports]="airports$ | async"
    [source]="source"
    [loadDefaultplaces]="loadDefaultplaces"
    (showMobileCalendarEvent)="showMobileCalendar($event)">
  </app-search-bar>
}

<router-outlet name="search"></router-outlet>
